import React, {useState, useEffect} from 'react';
import { IComponentLiveRich } from '../../component';
// import AllForText from '../ComponentRichText/AllForText';
import RenderComponent, {
  RenderComponentWithWrapper,
  RenderComponentWithPCWrapper
} from "../Gallery/RenderComponent";
import { direct } from '../../utils/image';
import RootStore from '../../store/RootStore';
import { inject, observer } from 'mobx-react';

import './AllForLiveRich.scss';

interface ILiveRichItem {
  id: string;
  hash: string;
  desc: string;
  createdAt: string;
  content?: string;
}
 
const AllForLiveRich = function(props: IComponentLiveRich) {
  const { richhash } = props; 
  const {pagedataStore} = props.rootStore!;

  const [list, setList] = useState([] as ILiveRichItem[]);
  
  const loadItem = async (item:ILiveRichItem)=>{
    if(item && item.hash) {
      const content = await window.fetch(`${direct(item.hash)}`).then(res=>res.text());
      if(content) {
        item.content = content;
      }
    }else {
      item.content = "";
    }

    setList(list.map((it:ILiveRichItem)=>{
      if(it.id == item.id) {
        return item;
      }
      return it;
    }));
  }

  const fetchList = async ()=>{
    const content = await window.fetch(`${direct(richhash)}?_t=${Date.now()}`).then(res=>res.json());
    if(content && content instanceof Array) {
      setList(content as ILiveRichItem[]);
    }
  };

  useEffect(()=>{
    if(richhash) {
      fetchList();
    }
  }, []);

  useEffect(()=>{
    const item = list.find(it=>!it.content && typeof it.content == 'undefined');
    if(item) {
      loadItem(item);
    }
  }, [list]);

  return (
    <div className="all-for-liverich">
      {list.map((item:ILiveRichItem)=>{
        const options = {
          key:item.id,
          cid:item.id,
          container:{top:0,bottom:20,left:0,right:0},
          richtext:item.content || "",
          type:"richtext"
        };
        if(pagedataStore.renderMode == 'pc') {
          return <RenderComponentWithPCWrapper {...options} />
        }else {
          
          return <RenderComponentWithWrapper {...options} />;
        }
      })}
    </div>
  );
};

export default inject('rootStore')(observer(AllForLiveRich));
